export default __webpack_public_path__ + "static/media/46.5b052fd4.png";